// Returns the current full year as a number
// Usage: getCurrentYear() -> 2026
export const getCurrentYear = () => new Date().getFullYear();